const ONE_WAY = 'ONE_WAY'
const ROUND_TRIP = 'ROUND_TRIP'
const RETAIL = 'RETAIL'
const EXPRESS_DEAL = 'EXPRESS_DEAL'

const LONG_TRIP_TYPE_FORMAT = {
  OW: ONE_WAY,
  RT: ROUND_TRIP,
}

export { LONG_TRIP_TYPE_FORMAT, RETAIL, EXPRESS_DEAL }
